import { useState, useEffect } from 'react';
import { taskTypeService } from '../services/tasks/taskTypeService.js';

export const useTaskTypes = () => {
  const [taskTypes, setTaskTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTaskTypes = async () => {
      try {
        setLoading(true);
        const { taskTypes: data } = await taskTypeService.getTaskTypes();

        // Transformar los datos para asegurar que tengan id y displayName
        const transformedData = data.map(item => ({
          ...item,
          name: item.name,
          displayName: item.displayName,
          categoryName: item.categoryName
        }));

        setTaskTypes(transformedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching task types:', err);
        setError(err.message);
        setTaskTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTaskTypes();
  }, []);

  return { taskTypes, loading, error };
};
